export interface FAQ {
  question: string;
  answer: string;
}
export const faqs: FAQ[] = [
  {
    question: "Como gerar um boletim diário?",
    answer: `Para gerar um boletim diário, vá até o menu lateral, clique em Boletim Diário, 
      selecione uma data no calendário e clique em gerar relatório e/ou exportar PDF.`,
  },
  {
    question: "Como gerar um boletim mensal?",
    answer: `Para gerar um boletim mensal, vá até o menu lateral, clique em Boletim Mensal, 
      selecione um mês no calendário e clique em buscar PDF.`,
  },
  {
    question: "Como fazer uma solicitação de serviço?",
    answer: `Para criar a solicitação de serviço, basta ir ao menu lateral, clicar em Solicitações de Serviço, 
      em seguida clicar em Criar Solicitação, adicionar as informações necessárias e confirmar os dados.`,
  },
  {
    question: "Como criar uma nova usina?",
    answer: `Para criar uma nova usina, vá até o menu lateral, clique em Administrativo, 
      em seguida selecione Usina, após ir até a página mostrando uma lista contendo usinas, 
      terá um botão de Adicionar Usina no canto inferior direito, 
      clique nele e adicione as informações importantes para que seja criada a nova usina.`,
  },
  {
    question: "Como habilitar ou desabilitar notificações?",
    answer: `Para habilitar ou desabilitar as notificações, vá no menu lateral, clique em Meus Dados, 
    em seguida clique em Perfil. Na lateral direita, habilite as notificações, depois marque o que você 
    deseja continuar recebendo notificações e desmarque o que não desejar mais, e após clique em Salvar.`,
  },
  {
    question: "Como criar um novo alarme?",
    answer: `Para criar um novo alarme, vá no menu lateral, clique em Administrativo, 
    em seguida clique em Matriz de Alarmes. No canto inferior direito, clique no botão Adicionar Matriz de Alarme,
    e adicione as informações importantes para que seja criado um novo alarme.`,
  },
  {
    question: "Como visualizar dados históricos do dashboard?",
    answer: `Na tela de dashboard você conseguirá filtrar os cartões pelo dia que desejar, 
    clicando no ícone de filtro que fica ao lado das notificações de Alarmes da Usina, no menu lateral.
    Irá abrir uma caixinha para selecionar pelo dia ao clicar no Filtro e alterar do Live para Dia, depois você 
    poderá digitar a data desejada ou clicar no ícone de calendário e selecionar uma data.`,
  },
];
